<template lang="html">
    <div class="single-container">
        <v-toolbar class="modal-header">
            <div class="app-logo">
                <img src="../../../assets/img/logo_s_pink.svg" />
            </div>
            <v-btn flat @click.native="onClose">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title v-if="symbol !== null && symbol !== undefined">Symbole / {{symbol.label}}</v-toolbar-title>
            <v-spacer></v-spacer>
           <div class="header-purple" v-if="symbol !== null && symbol !== undefined">
                {{symbol.requests.length}} produits liés
           </div>
        </v-toolbar>

        <v-toolbar flat class="single-toolbar" v-if="symbol !== null && symbol !== undefined">
            <avatar class="single-avatar" :item="symbol.user" size="5rem"></avatar>
            <v-layout column justify-space-around align-content-space-around>
                <v-flex> <b>{{symbol.user.first_name}} {{symbol.user.last_name}}</b></v-flex>
                <div class="date">
                    <pre class="date-line">  </pre>Le {{moment(symbol.updated_at).format('DD/MM/YYYY')}}
                </div>
            </v-layout>
            <v-btn v-if="isEditing" outline round depressed small :color="'primary'" @click="$refs.modal.open('symbols',symbol.id)" >Ajouter une pièce jointe</v-btn>
            <v-btn v-if="isEditing" round small flat :color="'primary'" @click="cancel()">Annuler</v-btn>
            <v-btn v-if="isEditing" round depressed small :color="'primary'" @click="saveElement()" :loading="loading">Enregistrer</v-btn>

            <v-btn v-if="!isEditing && ($store.state.auth.user.level >= 60 || symbol.user_id == $store.state.auth.user.id)" round small flat :color="'primary'" @click="deleteSymbol()">Supprimer le symbole</v-btn>
            <v-btn v-if="!isEditing && ($store.state.auth.user.level >= 60 || symbol.user_id == $store.state.auth.user.id)" round depressed small :color="'primary'" @click="startEditing()" >Modifier</v-btn>
        </v-toolbar>

        <div class="center-content" :class="[isCol(2,symbol) ? 'doubleCol' : '']" v-if="!isEditing && symbol !== null && symbol !== undefined">
            <v-layout row>
                <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)">
                    <div class="comment-title on-left">
                        {{symbol.title}}
                    </div>
                </v-flex>
                <v-flex v-if="isCol(2,symbol)" sm12 md6>
                    <div class="comment-title on-right">
                        {{symbol.title_2}}
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row >
                <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)">
                    <p class="comment-message on-left">
                        <span v-html="$options.filters.nl2br(symbol.message)"></span>
                    </p>
                </v-flex>
                <v-flex v-if="isCol(2,symbol)" sm12 md6>
                    <p class="comment-message on-right">
                        <span v-html="$options.filters.nl2br(symbol.message_2)"></span>
                    </p>
                </v-flex>
            </v-layout>

            <v-layout>
                <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)">
                    <v-layout wrap>
                        <v-flex  v-for="(file,index) in symbol.files_1" :key="file.id" @click="imgFullPath === null && openImg(file)">
                            <label class="comment-image">
                                <img :src="file.path"/>
                            </label>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex v-if="isCol(2,symbol)" sm12 md6>
                    <v-layout wrap>
                        <v-flex v-for="(file,index) in symbol.files_2" :key="file.id" @click="imgFullPath === null && openImg(file)">
                            <label class="comment-image">
                                <img :src="file.path"/>
                            </label>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>


        <div class="center-content" :class="[nb_column == 2 ? 'doubleCol' : '']" v-if="isEditing && symbol !== null && symbol !== undefined">
            <v-form v-model="valid_title" >
                <v-layout row class="title-row">
                    <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)" class="edit-title">
                        <v-text-field
                        name='titre1_text_field'
                        label='Titre'
                        hint='Titre de votre commentaire'
                        v-model="symbol.title"
                        :rules="rules.title"
                        :error="error"
                        :persistent-hint="error"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex v-if="isCol(2,symbol)" sm12 md6 class="edit-title">
                        <v-text-field
                        name='titre2_text_field'
                        label='Titre 2'
                        hint='Titre de votre commentaire 2'
                        v-model="symbol.title_2"
                        :rules="rules.title_2"
                        :error="error_2"
                        :persistent-hint="error_2"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>

            <v-form v-model="valid_message">
                <v-layout row>
                    <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)" class="edit-message">
                        <v-text-field
                        name='message_text_field'
                        label='Message'
                        hint='Contenu du message'
                        v-model="symbol.message"
                        multi-line
                        :error="error"
                        :persistent-hint="error"
                        >
                        </v-text-field>
                    </v-flex>
                    <v-flex v-if="isCol(2,symbol)" sm12 md6 class="edit-message">
                        <v-text-field
                        name='message_text_field2'
                        label='Message 2'
                        hint='Contenu du message 2'
                        v-model="symbol.message_2"
                        multi-line
                        :error="error_2"
                        :persistent-hint="error_2"
                        >
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>

            <!-- #region -- image -->
            <v-layout v-if="display" class="imgs">
                <v-flex :xs12="isCol(1,symbol)" :sm12="isCol(2,symbol)" :md6="isCol(2,symbol)">
                    <v-layout>
                        <v-flex v-for="(file,index) in symbol.files_1" :key="file.id" xs2>
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <v-icon class="hover-alpha">mode_edit</v-icon>
                                        <img :src="file.path"/>
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile class="li">
                                       <label :for="'file1-input-'+index">Modifier l'image</label>
                                       <input class="input-img" :id="'file1-input-'+index" style="display:none" type="file" @change="(event)=>{onFileChange(event,1,index)}"/>
                                   </v-list-tile>
                                   <v-list-tile @click="file.id ? $refs.deletefile.open('symbols',file, symbol.id) : $refs.deletefile.open('symbols',file,'files_1')" class="li">
                                       <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                        <v-flex v-if="symbol.files_1.length < 2" xs2>
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <img :src="addImgPath()" class="add-img"/>
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile class="li">
                                       <label :for="'file1-input'">Ajouter une image</label>
                                       <input class="input-img" id="file1-input" style="display:none" type="file" @change="(event)=>{onFileChange(event,1)}"/>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex v-if="isCol(2,symbol)" sm12 md6 >
                    <v-layout>
                        <v-flex v-for="(file,index) in symbol.files_2" :key="file.id" xs2>
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <v-icon class="hover-alpha">mode_edit</v-icon>
                                        <img :src="file.path"/>
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile class="li">
                                       <label :for="'file2-input-'+index">Modifier l'image</label>
                                       <input class="input-img" :id="'file2-input-'+index" style="display:none" type="file" @change="(event)=>{onFileChange(event,2,index)}"/>
                                   </v-list-tile>
                                   <v-list-tile @click="file.id ? $refs.deletefile.open('symbols',file, symbol.id) : $refs.deletefile.open('symbols',file,'files_2')" class="li">
                                       <v-list-tile-title>Supprimer l'image</v-list-tile-title>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>

                        <v-flex v-if="isCol(2,symbol) && symbol.files_2.length < 2" xs2>
                            <v-menu offset-y content-class="files">
                                <div slot="activator">
                                    <label class="comment-image">
                                        <img :src="addImgPath()" class="add-img" />
                                    </label>
                                </div>
                               <v-list>
                                   <v-list-tile class="li">
                                       <label :for="'file2-input'">Ajouter une image</label>
                                       <input class="input-img" id="file2-input" style="display:none" type="file" @change="(event)=>{onFileChange(event,2)}"/>
                                   </v-list-tile>
                               </v-list>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <!-- #endregion -->
        </div>

        <!-- #region -- files -->
        <template v-if="symbol && symbol.files">
            <template v-for="(file,index) in symbol.files" v-if="file.pivot && file.pivot.file_type == 'attachment' && display">
                <div class='files-list-container' @click="$eventHub.$emit('view-file',file)">
                    <div class="files-list-container-title">
                        Pièces jointes :
                    </div>
                    <template>{{file.label}}.{{file.type}}</template>
                    <v-spacer></v-spacer>
                    <v-btn icon v-if="isEditing" @click.stop="$refs.deletefile.open('symbols',file,symbol.id)">
                        <v-icon>close</v-icon>
                    </v-btn>
                </div>
            </template>
        </template>

        <!-- #endregion -->

        <div class="column-display-choice" v-if="isEditing">
            <div class="col-choice-title">
                Affichage :
            </div>
            <div class="column-display-buttons">
                <div>
                    <div @click="setColumnNumber(1)" class="image-and-overlay-left">
                        <img src="../../../assets/img/full.svg" class="col-chose-image"/>
                        <div v-if="nb_column===1" class="col-choice-overlay"></div>
                    </div>
                </div>
                <div>
                    <div @click="setColumnNumber(2)" class="image-and-overlay-right">
                        <img src="../../../assets/img/split.svg" class="col-chose-image"/>
                        <div v-if="nb_column===2" class="col-choice-overlay"></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="imgFullPath !== null" class="overlay">
            <div class="overlay-container" @click="openImg(null)">
                <img :src="imgFullPath" class="overlay-image" />
            </div>
        </div>

        <!-- #region -- confirm remove col modal -->

        <v-dialog v-model="removeCol" max-width="750px">
            <v-card>
                <v-card-title class="warning">
                    <h2>
                        <v-icon dark class="mr-2">warning</v-icon>
                        <span class="white--text">Attention</span>
                    </h2>
                    <v-spacer></v-spacer>
                    <v-btn small icon @click="removeCol = false">
                        <v-icon dark>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Voulez vous vraiment supprimer la deuxième colonne ?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn round small outline color="warning" @click.native="removeCol = false;">Annuler</v-btn>
                    <v-btn round depressed small color="warning" @click.native="deleteCol()">Valider</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- #endregion -->

        <!-- <delete-linked-file ref="deletefile" @deleted="function (entity_id,item_id) { deleteFile(entity_id,item_id) }"></delete-linked-file> -->
        <!-- #region -- files -> create, delete -->
        <create-linked-files ref="modal" @added="function (entity_id,entity) { addFile(entity_id,entity) }"></create-linked-files>
        <delete-linked-file ref="deletefile" @deleted="function (entity_id,item_id) { deleteFile(entity_id,item_id) }"></delete-linked-file>
        <!-- #endregion -->
    </div>
</template>

<script>
import Avatar   from '../../../components/avatar/Avatar.vue'
import moment from 'moment'
import Delete 		from './Delete'
import CreateLinkedFiles  from '../../../components/files/CreateLinkedFiles.vue'
import DeleteLinkedFile   from '../../../components/files/DeleteLinkedFiles.vue'
import nl2br             from '../../../filters/nl2br'


export default {
    props: {
        params: {
            required: true,
        }
    },
    components: {
        Avatar,Delete,DeleteLinkedFile,CreateLinkedFiles,
    },
    data() {
        return {
            moment,
            display: true,
            symbol:null,
            fullscreen: true,
            card_text_class: 'fullscreen-modal-text',
            valid_button: false,
            cancel_button: false,
            imgFullPath :null,
            isEditing : false,
            nb_column:1,
            valid_title: false,
            valid_message: false,
            savedSymbol : null,
            error: false,
            error_2: false,
            removeCol: false,
            loading: false,
            rules: {
                title: [
                    function(v){
                        if(!!v && v.length <= 0) {
                            return 'Titre obligatoire'
                        } else if(v.length >= 150) {
                            return 'Le titre ne dois pas contenir plus de 150 caractères'
                        } else {
                            return true
                        }
                    }
                ],
                title_2: [
                    function(v){
                        if(v) {
                            if(v.length >= 150) {
                                return 'Le titre ne dois pas contenir plus de 150 caractères'
                            } else {
                                return true
                            }
                        } else {
                            return true
                        }
                    }
                ]
            }
        }
    },
    methods: {
        deleteFile(entity,item){
            this.display = false
            let index = ''
            let file_array = ''
            //if file already saved
            if(typeof entity == 'number') {
                this.$_.find(this.symbol.files_1, i => i.id == item) ? file_array = 'files_1' : file_array = 'files_2'
                this.$_.find(this.symbol.files, i => i.id == item) && this.$_.find(this.symbol.files, i => i.id == item).pivot.file_type == 'attachment' ? file_array = 'files' : file_array = file_array
                index = this.symbol[file_array].findIndex((el)=>el.id === item)
            } else {
                index = this.symbol[entity].findIndex((el)=>el.path === item)
                file_array = entity
            }
            this.symbol[file_array].splice(index,1)
            this.display = true
        },

        addFile(entity_id,entity){
            this.display = false
            if(entity_id != 0) {
                this.axios.get(`/api/${entity}?embed=files&filters=id|=|${entity_id}`)
                .then(response => {
                    this.symbol.files = response.data[0].files
                })
            }
            this.display = true

        },
        onClose:function() {
            this.$eventHub.$emit('close-modal');
            this.$eventHub.$emit('reload-single');
            this.$eventHub.$emit('reload-list');

        },
        openImg:function (file){
            this.$eventHub.$emit('view-file', file)
        },
        onFileChange(evt,fileArray ,fileIndex){
            this.display = false
            let array = this.symbol['files_' + fileArray];
            if (fileIndex >= 0){
                if(evt.target.files[0]) {
                    array[fileIndex].path = URL.createObjectURL(evt.target.files[0]);
                    array[fileIndex].file = evt.target.files[0];
                    array[fileIndex].toUpdate=true;
                }
            } else {
                fileIndex =array.length;
                if(evt.target.files[0]) {
                    array.push({
                        path:URL.createObjectURL(evt.target.files[0]),
                        file:evt.target.files[0],
                        toUpdate:true
                    })
                }
            }
            this.display = true
        },
        addImgPath() {
            return require('../../../assets/img/addimg.svg')
        },
        setColumnNumber(nb_column) {
            this.nb_column=nb_column;
        },
        isCol(number,symbol) {
            if(!this.isEditing) {
                if(number===1) {
                    return false
                } else {
                    return true;
                }
            } else {
                if(this.nb_column === number) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        deleteCol(){
            this.symbol.message_2 = null
            this.symbol.title_2 = null
            this.removeCol = false
            this.nb_column = 1
        },
        cancel:function (){
            this.isEditing=false;
            this.getDataFromApi();
        },
        startEditing:function (){
            this.isEditing=true;
            if(this.symbol && (this.symbol.title_2 != null || this.symbol.message_2 != null)) {
                this.nb_column = 2
            }
        },
        deleteSymbol:function (){
            this.$eventHub.$emit('open-modal2', Delete)
        },
        saveElement : function (){
            if(this.valid_title && this.valid_message){
                if(this.nb_column == 2 && this.symbol.title_2 == null || this.nb_column == 2 && this.symbol.message_2 == null) {
                    this.error_2 = true
                } else {
                    this.loading = true
                    let savePhotoRec =(symboleId,arrayId,index)=>{
                        if (arrayId < 3) {
                            if (index < this.symbol['files_' + arrayId].length){
                                let file =this.symbol['files_' + arrayId][index];

                                if (file.file !== null && file.file !== undefined){
                                    let data = new FormData();
                                        data.append('file',file.file),
                                        data.append('location','area-' + arrayId);

                                    if (file.id >0){
                                        this.axios.delete(`/api/symbols/${symboleId}/file/${file.id}`,data)
                                            .then(response => {
                                                this.axios.post(`/api/symbols/${symboleId}/file`,data)
                                                    .then(response => {
                                                        savePhotoRec(symboleId,arrayId,++index);
                                                        this.loading = false
                                                    });
                                            });
                                    } else {
                                        this.axios.post(`/api/symbols/${symboleId}/file`,data)
                                            .then(response => {
                                                savePhotoRec(symboleId,arrayId,++index);
                                                this.loading = false
                                            });
                                    }
                                } else {
                                    savePhotoRec(symboleId,arrayId,++index);
                                    this.loading = false
                                }
                            } else {
                                 savePhotoRec(symboleId,++arrayId,0);
                                 this.loading = false
                            }
                        }
                    };
                    this.axios.put('/api/symbols/'+this.symbol.id,{
                            label: this.symbol.title,
                            title: this.symbol.title,
                            title_2: this.symbol.title_2,
                            message: this.symbol.message,
                            message_2:this.symbol.message_2,
                            user_id : this.$store.state.auth.user.id
                        })
                        .then(response => {
                            this.isEditing=false;
                            savePhotoRec(response.data.id,1,0);
                            this.loading = false
                        });
                }
            } else {
                this.error = true
            }
        },
        getDataFromApi:function(){
            this.axios.get(`/api/symbols/${this.params.id}?embed=requests,files,user`)
                .then(response => {
                    this.symbol = response.data;
                    this.symbol.files_1 = this.symbol.files.filter(file=>file.pivot.location === 'area-1');
                    this.symbol.files_2 = this.symbol.files.filter(file=>file.pivot.location === 'area-2');
                    if(this.symbol && (this.symbol.title_2 != null || this.symbol.message_2 != null)) {
                        this.nb_column = 2
                    }
                    this.$store.dispatch('setSingleData', { data: this.symbol })
                });
        }
    },
    created(){
        this.getDataFromApi();
        this.isEditing = this.params.isEditing;

    }
}
</script>

<style lang="stylus" scoped>
    @require '../../../assets/css/variables'
    .files {
        label {
            font-size: 1.6rem
            height: 100%
            width: 100%
            display: flex
            align-items: center
            cursor: pointer
        }
    }
    $header-hight = 60px
    .modal-header {
        position: relative
        display:flex
        justify-content: flex-start
        align-items center
        z-index: 2
        height: $header-hight
        background: white
        box-shadow: 0 0 33px 0 #EBEFF5 !important
        div.app-logo {
            height: $app-nav-width
            display: flex
            align-items:center
            justify-content:center
            border-right: 1px solid $border-light-color
            border-bottom: 1px solid $border-light-color
            padding: 0 2.5rem
            margin-left: 0 !important
            img {
                max-width: 100%
            }
        }

        & >>> button.btn {
            padding: 0
            margin:0
            min-width: auto
            height: 100%
        }
        .header-purple {
            position: absolute
            right: 120px
            color : $primary-color
        }

    }
    .single-container {
        margin: 0
        .single-toolbar {
            margin-left: 65px
            margin-right: 125px
            margin-top: 56px !important
            background: white
            width: calc(100% - 190px)
            .single-avatar{
                margin: 10px
            }
            .date {
                display:flex
                font-size:1.2rem
                .date-line {
                    margin:8px
                    width:15px;
                    background: #000
                    height:1px;
                }
            }
        }
        .column-display-choice {
            padding: 0 5rem
            position: absolute
            bottom: 1rem
            background: white
            font-size: 2rem
            width: 100%;
            height: 70px !important
            align-items: center
            cursor: pointer
            .column-display-buttons{
                display: inline-flex
                position: relative
                top: 0
                left: 0
                .image-and-overlay-left {
                    position: relative
                    bottom: 25px
                    left: 0
                    cursor: pointer
                }
                .image-and-overlay-right {
                    position: relative
                    bottom: 25px
                    left: 80px
                    cursor: pointer
                }
                .col-chose-image {
                    position: absolute
                    top: 0
                    left: 0
                    width:70px
                    height: 35px
                    margin: 10px
                    margin-top: 5px
                    padding: 0
                }
                .col-choice-overlay {
                    position: absolute
                    top: 0
                    left: 0
                    width:70px
                    height 35px
                    background: rgba(252,225,255,0.5);
                    box-shadow: 0 8px 18px 0 rgba(253,232,255,1);
                    border-radius: 10px;
                    margin: 10px
                    margin-top: 5px
                    z-index:10
                }
            }
        }
        .center-content {
            input {
                display: none;
            }
            position: relative;
            margin-top: 60px
            margin-left: 100px
            margin-right: 100px
            width: calc(100% - 200px)
            .title-row{
                max-height: 80px !important
            }
            .edit-title {
                margin-bottom: 0  !important
                margin-top: 0  !important
                margin: 2rem !important
                border-color: black !important
                border-width: 10px !important
                border-radius: 8px !important
                font-size: 50px !important
                max-height: 80px !important
            }

            .comment-title {
                padding-bottom: 1rem
                padding-top: 1rem
                font-size: 5rem !important
            }

            .edit-message {
                margin-bottom: 0
                margin: 2rem !important
                margin-top: 0 !important
                border-color: black !important
                border-width: 10px !important
                border-radius: 8px !important
                font-size: 50px !important
            }

            .comment-message {
                width: 100%
                padding-bottom: 0
                font-size: 2rem
                margin-bottom: 2rem
            }

            .on-left {
                padding-right: 1rem
            }
            .on-right {
                padding-left: 1rem
            }

            .comment-image {
                margin-top: 25px
                height: 150px
                width: 150px
                margin-bottom: 10px
                background-color: rgba(0,0,0,0.68)
                cursor: pointer
                display: block
                img {
                    width:100%
                    height:100%
                    object-fit: contain
                    background-color: #FFF
                    &.add-img {
                        padding: 40px !important
                        background-color: rgba(0, 0, 0, 0.5)
                    }
                }
                .hover-alpha {
                    height: 100%
                    width: 100%
                    position: absolute
                    margin-bottom: 35px
                    &:not(hover) {
                        background-color: rgba(0, 0, 0, 0);
                        color: rgba(0, 0, 0, 0);
                    }
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.5);
                        color: white;
                    }
                }
            }

            .comment-no-image {
                height: 150px
                width: 150px
                margin-bottom: 35px
            }
            @media screen and (max-width: 900px){
                &.doubleCol {
                    .layout {
                        flex-direction: column
                        .flex {
                            &:last-of-type{
                                position: relative
                                top: 33rem
                            }
                        }
                    }
                    form{
                        .layout {
                            flex-direction: column
                            .edit-title {
                                &:last-of-type{
                                    position: relative
                                    top: 40rem
                                }
                            }
                            .edit-message {
                                &:last-of-type{
                                    position: relative
                                    top: 33rem
                                }
                            }
                        }
                        &:last-of-type{
                            height: 19rem
                        }
                    }
                    .layout.imgs {
                        flex-direction: column
                        .flex.sm12 {
                            &:last-of-type{
                                position: relative
                                top: 33rem
                            }
                        }
                    }
                }
            }
        }
    }
    .overlay {
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        .overlay-container{
            z-index: 4
            display: flex
            flex-direction: column
            align-items: center
            justify-content: center
            width: 50%
            height:  50%
            .overlay-image {
                max-width: 50%
                max-height:  50%
            }
        }
        position: fixed
        top: 0
        left: 0
        width: 100%
        height: 100%
        z-index: 10
        background-color: rgba(0,0,0,0.5)
    }
    .files-list-container {
        padding: 1rem 1.5rem
        position: relative
        margin-top: 15px
        background: #eee
        font-size: 1.7rem
        border-radius: 5px
        border-width: 2px
        border-color: blue
        width: 'calc(100% - (%s * 2) + 2rem)' % $content-margin
        color: $primary-color
        display: inline-flex
        font-weight: bold
        align-items: center
        cursor: pointer
        margin-left: 100px
        margin-right: 100px
        width: calc(100% - 200px)
        height: 6rem
        .files-list-container-title {
            font-style: italic
            color: black
            padding-right: 1rem
            font-weight: normal
        }
    }

</style>



// WEBPACK FOOTER //
// src/views/symbols/list/Single.vue